import _ from 'lodash';
import {
  IotOrderTypes,
  IotViewTypes,
  IotTerm3Year,
  IotRaven5CAN_USNon_Share,
  IotRaven5Non_Share,
  IotRavenDevice,
  IotProductGeoTab,
  IotProductGeoforce,
  IotOBDYSplitter,
  IotRaven
} from '../../../utils/constant';

export const DELIVERY_CHARGE = 20;

export const getRateplanTotal = ratePlans =>
  Object.keys(ratePlans).reduce(
    (acc, current) => {
      const ratePlanTotal = Object.keys(ratePlans[current]).reduce(
        (rateplanAcc, item) => {
          const { quantity, unitPrice } = ratePlans[current][item];
          if (quantity && unitPrice)
            return {
              ...rateplanAcc,
              monthly: rateplanAcc.monthly + unitPrice * quantity
            };
          return rateplanAcc;
        },
        { monthly: 0, oneTime: 0 }
      );
      return {
        monthly: acc.monthly + ratePlanTotal.monthly,
        oneTime: acc.oneTime + ratePlanTotal.oneTime
      };
    },
    { monthly: 0, oneTime: 0 }
  );

export const getRateplanTotalQuantity = ratePlans =>
  Object.entries(ratePlans).reduce((acc, [, devicesObj]) => {
    const totalQuantity = Object.entries(devicesObj).reduce(
      (accInner, [, detailsObj]) =>
        accInner + +_.get(detailsObj, 'quantity', 0),
      0
    );
    return acc + totalQuantity;
  }, 0);

export const getRateplanTotalQuantityNssFramAndRanch = ratePlans =>
  Object.entries(ratePlans).reduce((acc, [rateplan, devicesObj]) => {
    if (rateplan === 'TELUS Farm Inventory Management Software') return acc;
    const totalQuantity = Object.entries(devicesObj).reduce(
      (accInner, [deviceName, detailsObj]) => {
        if (deviceName === 'Smart Dock')
          return accInner + +_.get(detailsObj, 'quantity', 0);
        return accInner;
      },
      0
    );
    return acc + totalQuantity;
  }, 0);

export const getTotalSmartDocks = hardware =>
  Object.entries(hardware).reduce((acc, [hardwareName, hardwareDetails]) => {
    if (hardwareName === 'Smart Dock')
      return acc + hardwareDetails.additionalQuantity;
    return acc;
  }, 0);

export const getDeliveryCharges = ratePlans =>
  getRateplanTotalQuantity(ratePlans) * DELIVERY_CHARGE;

export const checkGeoTabNewPricing = (productSelected, orderType, accountTypes = [], accountType, viewType, rateplanName, terms = [''], term = '') => {
  if (
    (productSelected === IotProductGeoTab || productSelected === IotProductGeoforce) &&
    IotOrderTypes.includes(orderType) &&
    accountTypes.includes(accountType) &&
    IotViewTypes.includes(viewType) &&
    [IotRaven5CAN_USNon_Share, IotRaven5Non_Share].includes(rateplanName) &&
    terms.includes(term)
  ) return true;
  return false;
}

export const checkGeoforceNewPricing = (productSelected, orderType, accountTypes = [], accountType, viewType, rateplanName, terms = [''], term = '') => {
  // Geoforce pricing logic - currently same as Geotab, but can be customized if needed
  if (
    productSelected === IotProductGeoforce &&
    IotOrderTypes.includes(orderType) &&
    accountTypes.includes(accountType) &&
    IotViewTypes.includes(viewType) &&
    [IotRaven5CAN_USNon_Share, IotRaven5Non_Share].includes(rateplanName) &&
    terms.includes(term)
  ) return true;
  return false;
}


export const setGeoTabNewPrice = (rateplanName, ratePlans, setGeoTabNewPriceValid, term) => {
  if (rateplanName === IotRaven5Non_Share) {
    if (
      ratePlans[IotRaven5CAN_USNon_Share] &&
      ratePlans[IotRaven5CAN_USNon_Share][IotRavenDevice] &&
      ratePlans[IotRaven5CAN_USNon_Share][IotRavenDevice].term === IotTerm3Year &&
      ratePlans[IotRaven5CAN_USNon_Share][IotRavenDevice].quantity > 0
    ) {
      setGeoTabNewPriceValid(true);
    }
    else setGeoTabNewPriceValid(false);
    if (
      !term &&
      ratePlans[IotRaven5CAN_USNon_Share] &&
      ratePlans[IotRaven5CAN_USNon_Share][IotRavenDevice] &&
      !ratePlans[IotRaven5CAN_USNon_Share][IotRavenDevice].term
    ) setGeoTabNewPriceValid(false);
  } else if (rateplanName === IotRaven5CAN_USNon_Share) {
    if (
      ratePlans[IotRaven5Non_Share] &&
      ratePlans[IotRaven5Non_Share][IotRavenDevice] &&
      ratePlans[IotRaven5Non_Share][IotRavenDevice].term === IotTerm3Year &&
      ratePlans[IotRaven5Non_Share][IotRavenDevice].quantity > 0
    ) {
      setGeoTabNewPriceValid(true);
    }
    else setGeoTabNewPriceValid(false);
    if (
      !term &&
      ratePlans[IotRaven5Non_Share] &&
      ratePlans[IotRaven5Non_Share][IotRavenDevice] &&
      !ratePlans[IotRaven5Non_Share][IotRavenDevice].term
    ) setGeoTabNewPriceValid(false);
  }
}

export const setGeoTabNewPriceTerm = (rateplanName, ratePlans, setGeoTabNewPriceValid, term) => {
  if (rateplanName === IotRaven5Non_Share) {
    if (
      !term &&
      ratePlans[IotRaven5CAN_USNon_Share] &&
      ratePlans[IotRaven5CAN_USNon_Share][IotRavenDevice] &&
      !ratePlans[IotRaven5CAN_USNon_Share][IotRavenDevice].term
    ) setGeoTabNewPriceValid(false);
  } else if (rateplanName === IotRaven5CAN_USNon_Share) {
    if (
      !term &&
      ratePlans[IotRaven5Non_Share] &&
      ratePlans[IotRaven5Non_Share][IotRavenDevice] &&
      !ratePlans[IotRaven5Non_Share][IotRavenDevice].term
    ) setGeoTabNewPriceValid(false);
  }
}

export const setAdditionalRavenDevices = (rateplanName, quantity, setHardware, term) => {
  setHardware(previousValue => ({
    ...previousValue,
    [IotOBDYSplitter]: {
      ...previousValue[IotOBDYSplitter],
      [IotRaven[rateplanName]]: term ? quantity : 0
    }
  }));
}